import { postVisibilityExportV2 } from "../../../actions/admin"
import { stateConvert } from '../../../../web/components/utils/stateAbbreviation';
import moment from "moment";

const orderType = (items, bidQty) => {
  let totalQuantity = (bidQty && bidQty !== 0 && bidQty !== null) ? bidQty : (items?.postQuantity ? items?.postQuantity : items?.quantity ? items?.quantity : '')
  let material = items?.palletDetails?.material
  material = material?.toString()
  material = material?.toLowerCase();
  material = material?.replace(/\b\w/g, c => c.toUpperCase())
  let condition
  if (items?.palletDetails?.condition?.length !== 1) {
    condition = items?.palletDetails?.condition?.join(", ")
    condition = condition?.toString()
    condition = condition?.toLowerCase();
    condition = condition?.replace(/\b\w/g, c => c.toUpperCase())
  } else {
    if (items?.palletDetails?.condition.length !== 0)
      condition = items?.palletDetails?.condition
    condition = condition?.toString()
    condition = condition?.toLowerCase();
    condition = condition?.replace(/\b\w/g, c => c.toUpperCase())
  }

  let palletType;
  let moisture = "";
  let size = "";
  let grade = "";
  let LWH
  if (items?.palletDetails?.material !== "WOOD") {
    const length = items?.palletDetails?.length
    const width = items?.palletDetails?.width
    const height = items?.palletDetails?.height
    LWH = length + "x" + width + "x" + height

    if (condition) {
      condition = condition?.toString()
      condition = condition?.toLowerCase();
      condition = condition?.replace(/\b\w/g, c => c.toUpperCase())
      if (totalQuantity) {
        return totalQuantity + " - " + material + "-" + LWH + "-" + condition
      } else {
        return material + "-" + LWH + "-" + condition
      }

    } else {
      if (totalQuantity) {
        return totalQuantity + " -" + material + " - " + LWH
      } else {
        return material + " - " + LWH
      }

    }

  } else {
    palletType = items?.palletDetails?.palletType
    if (items?.palletDetails?.moisture)
      moisture = " - " + items?.palletDetails?.moisture

    if (items?.palletDetails?.size)
      size = items?.palletDetails?.size

    if (items?.palletDetails?.grade)
      grade = " - " + items?.palletDetails?.grade

    palletType = palletType?.toLowerCase();
    palletType = palletType?.replace(/\b\w/g, c => c.toUpperCase())
    condition = condition?.toString()
    condition = condition?.toLowerCase();
    condition = condition?.replace(/\b\w/g, c => c.toUpperCase())
    if (totalQuantity) {
      return totalQuantity + " - " + size + "" + grade + "" + moisture + " - " + palletType + "-" + condition
    } else {
      return size + "" + grade + "" + moisture + " - " + palletType + "-" + condition
    }
  }
}

const setNeedCSVDate = (resultData) => {
  let tempCsvData = resultData.map((items) => {
    let deliveryaddress
    if (items?.postDetails?.shippingAddress?.address2) {
      deliveryaddress = items?.postDetails?.shippingAddress?.address1 + " - " + items?.postDetails?.shippingAddress?.address2
    } else {
      deliveryaddress = items?.postDetails?.shippingAddress?.address1
    }

    let quantityOrderType = orderType(items?.postDetails)
    let getDate = items?.postTimeLeftDate
    if (items?.postBidOrOfferInfo.length !== 0) {
      let resultObj = items?.postBidOrOfferInfo?.map((data, index) => {
        let postBidAddress = ''
        if (data?.shippingAddress) {
          if (data?.shippingAddress?.address2) {
            postBidAddress = data?.shippingAddress?.address1 + '-' + data?.shippingAddress?.address2 + '-' + data?.shippingAddress?.city + '(' + (data?.shippingAddress?.stateAbv ? data?.shippingAddress?.stateAbv : stateConvert(data?.shippingAddress?.state)) + ')'
          }
          else {
            postBidAddress = data?.shippingAddress?.address1 + '-' + data?.shippingAddress?.city + '(' + (data?.shippingAddress?.stateAbv ? data?.shippingAddress?.stateAbv : stateConvert(data?.shippingAddress?.state)) + ')'
          }
        }

        if (index === 0) {
          let mainReturnObj = {
            PostName: items?.postName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
            PosterEmail: items?.posterDetails?.email,
            PosterCompanyName: items?.postDetails?.shippingAddress?.locationName?.replaceAll(",", " ").replaceAll(".", " ").replaceAll("\n", " ")?.replaceAll("\r", " "),
            PrivateGroup: items?.postDetails?.private ? 'Yes' : 'No',
            Deliveryaddress: deliveryaddress,
            City: items?.postDetails?.shippingAddress?.city ? items.postDetails.shippingAddress.city.replace(/,$/, '') : '',
            State: (items?.postDetails?.shippingAddress?.stateAbv ? items?.postDetails?.shippingAddress?.stateAbv : stateConvert(items?.postDetails?.shippingAddress?.state)),
            Zip: 'Zip: ' + items?.postDetails?.shippingAddress?.zipCode,
            Contactno: items?.posterDetails?.phoneNumber,
            QuantityOrderType: quantityOrderType?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),

            Price: items?.postDetails?.postPrice ? `$${items.postDetails.postPrice}` : 'NA',
            ReqDelPUDate: items?.postDetails?.requestDeliveryDate && moment(items?.postDetails?.requestDeliveryDate.split('T')[0]).format("MM/DD/YYYY"),
            TotalBidsReceived: items?.noOfBidsAndOffers,
            TimeClockofBidEndTime: getDate,
            Comments: items?.adminComments && items?.adminComments?.postCommentByAdmin && items?.adminComments?.postCommentByAdmin[0]?.msg || '',
            AccountRep: items?.accountRepresentative ? items?.accountRepresentative.join(' - ') : "NA",

            BidderEmail: '',
            BidderCompanyname: '',
            BidderContactno: "",
            BidderQuantity: '',

            BidderDate: '',
            BidderDeliveryPUaddress: "",
            PostStatus: items?.postStatus,
            BidStatus: items?.postBidOrOfferStatus && items?.postBidOrOfferStatus,

            BidderAccountRep: "",
            BidderComment: '',
          }

          let chidReturnObj = {
            PostName: "",
            PosterEmail: "",
            PosterCompanyName: "",
            PrivateGroup: "",
            Deliveryaddress: "",

            City: "",
            State: "",
            Zip: "",
            Contactno: "",
            QuantityOrderType: "",

            Price: "",
            ReqDelPUDate: "",
            TotalBidsReceived: "",
            TimeClockofBidEndTime: "",
            Comments: "",
            AccountRep: "",

            BidderEmail: data?.bidderEmail || '',
            BidderCompanyname: data?.bidderCompanyName?.replaceAll(",", " ").replaceAll(".", " ").replaceAll("\n", " ")?.replaceAll("\r", " ") || '',
            BidderContactno: data?.bidderPhoneNumber || '',
            BidderQuantity: data?.palletDetails ? orderType(data) + ' - $' + data?.bidPrice : '',
            BidderDate: 'NA',//moment(data?.bidDate.split('T')[0]).format("MM/DD/YYYY") || '',
            BidderDeliveryPUaddress: postBidAddress,

            PostStatus: items?.postStatus,
            BidStatus: data?.bidStatus,

            BidderAccountRep: data?.bidderAccountRepresentative ? data?.bidderAccountRepresentative.join(' - ') : "NA",
            BidderComment: data?.bidComment || '',
          }
          return [mainReturnObj, chidReturnObj]
        } else {
          let chidReturnObj = {
            PostName: "",
            PosterEmail: "",
            PosterCompanyName: "",
            PrivateGroup: "",
            Deliveryaddress: "",

            City: "",
            State: "",
            Zip: "",
            Contactno: "",
            QuantityOrderType: "",

            Price: "",
            ReqDelPUDate: "",
            TotalBidsReceived: "",
            TimeClockofBidEndTime: "",
            Comments: "",
            AccountRep: "",

            BidderEmail: data?.bidderEmail || '',
            BidderCompanyname: data?.bidderCompanyName?.replaceAll(",", " ").replaceAll(".", " ").replaceAll("\n", " ")?.replaceAll("\r", " ") || '',
            BidderContactno: data?.bidderPhoneNumber || '',
            BidderQuantity: data?.palletDetails ? orderType(data) + ' - $' + data?.bidPrice : '',
            BidderDate: 'NA',
            BidderDeliveryPUaddress: postBidAddress,

            PostStatus: items?.postStatus,
            BidStatus: data?.bidStatus,

            BidderAccountRep: data?.bidderAccountRepresentative ? data?.bidderAccountRepresentative.join(' - ') : "NA",
            BidderComment: data?.bidComment || '',
          }
          return chidReturnObj
        }
      })
      return resultObj.flat()
    } else {
      let postBidAddress = ''
      if (items?.postBidOrOfferInfo && items?.postBidOrOfferInfo[0]?.shippingAddress) {
        if (items?.postBidOrOfferInfo[0]?.shippingAddress?.address2) {
          postBidAddress = items?.postBidOrOfferInfo[0]?.shippingAddress?.address1 + '-' + items?.postBidOrOfferInfo[0]?.shippingAddress?.address2 + '-' + items?.postBidOrOfferInfo[0]?.shippingAddress?.city + '(' + (items?.postBidOrOfferInfo[0]?.shippingAddress?.stateAbv ? items?.postBidOrOfferInfo[0]?.shippingAddress?.stateAbv : stateConvert(items?.postBidOrOfferInfo[0]?.shippingAddress?.state)) + ')'
        }
        else {
          postBidAddress = items?.postBidOrOfferInfo[0]?.shippingAddress?.address1 + '-' + items?.postBidOrOfferInfo[0]?.shippingAddress?.city + '(' + (items?.postBidOrOfferInfo[0]?.shippingAddress?.stateAbv ? items?.postBidOrOfferInfo[0]?.shippingAddress?.stateAbv : stateConvert(items?.postBidOrOfferInfo[0]?.shippingAddress?.state)) + ')'
        }
      }

      let mainReturnObj = {
        PostName: items?.postName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        PosterEmail: items?.posterDetails?.email,
        PosterCompanyName: items?.postDetails?.shippingAddress?.locationName?.replaceAll(",", " ").replaceAll(".", " ").replaceAll("\n", " ")?.replaceAll("\r", " "),
        PrivateGroup: items?.postDetails?.private ? 'Yes' : 'No',
        Deliveryaddress: deliveryaddress,

        City: items?.postDetails?.shippingAddress?.city ? items.postDetails.shippingAddress.city.replace(/,$/, '') : '',
        State: items?.postDetails?.shippingAddress?.stateAbv ? items?.postDetails?.shippingAddress?.stateAbv : stateConvert(items?.postDetails?.shippingAddress?.state),
        Zip: 'Zip: ' + items?.postDetails?.shippingAddress?.zipCode,
        Contactno: items?.posterDetails?.phoneNumber,
        QuantityOrderType: quantityOrderType?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),

        Price: items?.postDetails?.postPrice ? `$${items.postDetails.postPrice}` : 'NA',
        ReqDelPUDate: items?.postDetails?.requestDeliveryDate && moment(items?.postDetails?.requestDeliveryDate.split('T')[0]).format("MM/DD/YYYY"),
        TotalBidsReceived: items?.noOfBidsAndOffers,
        TimeClockofBidEndTime: getDate,
        Comments: items?.postcomments && items?.adminComments?.postCommentByAdmin && items?.adminComments?.postCommentByAdmin[0]?.msg || '',
        AccountRep: items?.accountRepresentative ? items?.accountRepresentative.join(' - ') : "NA",

        BidderEmail: items?.postBidOrOfferInfo[0]?.bidderEmail || '',
        BidderCompanyname: items?.postBidOrOfferInfo[0]?.bidderCompanyName?.replaceAll(",", " ").replaceAll(".", " ").replaceAll("\n", " ")?.replaceAll("\r", " ") || '',
        BidderContactno: items?.postBidOrOfferInfo[0]?.bidderPhoneNumber,
        BidderQuantity: items?.postBidOrOfferInfo[0]?.palletDetails ? orderType(items?.postBidOrOfferInfo[0]) + ' - $' + items?.postBidOrOfferInfo[0]?.bidPrice : '',
        BidderDate: 'NA',
        BidderDeliveryPUaddress: postBidAddress,
        PostStatus: items?.postStatus,
        BidStatus: items?.postBidOrOfferStatus && items?.postBidOrOfferStatus,
        BidderAccountRep: items?.postBidOrOfferInfo[0]?.bidderAccountRepresentative ? items?.postBidOrOfferInfo[0]?.bidderAccountRepresentative.join(' - ') : "NA",
        BidderComment: items?.postBidOrOfferInfo[0]?.bidComment || '',
      }

      return (mainReturnObj)
    }

  })
  // setNeedCsvData(tempCsvData.flat())
  return tempCsvData.flat()
}

const setInvCSVData = (resultData) => {
  let tempCsvData = resultData.map((items) => {
    let deliveryaddress
    if (items?.postDetails?.shippingAddress?.address2) {
      deliveryaddress = items?.postDetails?.shippingAddress?.address1 + " - " + items?.postDetails?.shippingAddress?.address2
    } else {
      deliveryaddress = items?.postDetails?.shippingAddress?.address1
    }
    let quantityOrderType = orderType(items?.postDetails)
    let getDate = items?.postTimeLeftDate
    if (items?.postBidOrOfferInfo.length !== 0) {
      let resultObj = items?.postBidOrOfferInfo?.map((data, index) => {
        let postBidAddress = ''
        if (data?.shippingAddress) {
          if (data?.shippingAddress?.address2) {
            postBidAddress = data?.shippingAddress?.address1 + '-' + data?.shippingAddress?.address2 + '-' + data?.shippingAddress?.city + '(' + (data?.shippingAddress?.stateAbv ? data?.shippingAddress?.stateAbv : stateConvert(data?.shippingAddress?.state)) + ')'
          }
          else {
            postBidAddress = data?.shippingAddress?.address1 + '-' + data?.shippingAddress?.city + '(' + (data?.shippingAddress?.stateAbv ? data?.shippingAddress?.stateAbv : stateConvert(data?.shippingAddress?.state)) + ')'
          }
        }
        if (index === 0) {
          let mainReturnObj = {
            PostName: items?.postName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
            PosterEmail: items?.posterDetails?.email,
            PosterCompanyName: items?.postDetails?.shippingAddress?.locationName?.replaceAll(",", " ").replaceAll(".", " ").replaceAll("\n", " ")?.replaceAll("\r", " "),
            PrivateGroup: items?.postDetails?.private ? 'Yes' : 'No',
            Deliveryaddress: deliveryaddress,
            City: items?.postDetails?.shippingAddress?.city ? items.postDetails.shippingAddress.city.replace(/,$/, '') : '',
            State: (items?.postDetails?.shippingAddress?.stateAbv ? items?.postDetails?.shippingAddress?.stateAbv : stateConvert(items?.postDetails?.shippingAddress?.state)),
            Zip: 'Zip: ' + items?.postDetails?.shippingAddress?.zipCode,
            Contactno: items?.posterDetails?.phoneNumber,
            QuantityOrderType: quantityOrderType?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
            Price: items?.postDetails?.postPrice ? `$${items.postDetails.postPrice}` : 'NA',
            TotalOffersReceived: items?.noOfBidsAndOffers,
            TimeClockofBidEndTime: getDate,
            Comments: items?.postcomments && items?.adminComments?.postCommentByAdmin && items?.adminComments?.postCommentByAdmin[0]?.msg,
            AccountRep: items?.accountRepresentative ? items?.accountRepresentative.join(' - ') : "NA",

            BidderEmail: '',
            BidderCompanyname: '',
            BidderContactno: '',
            BidderQuantity: '',
            BidderDate: '',
            BidderDeliveryPUaddress: '',

            PostStatus: items?.postStatus,
            OfferStatus: items?.postBidOrOfferStatus,

            BidderAccountRep: "",
            BidderComment: '',
          }
          let chidReturnObj = {
            PostName: "",
            PosterEmail: "",
            PosterCompanyName: "",
            PrivateGroup: "",
            Deliveryaddress: "",

            City: "",
            State: "",
            Zip: "",
            Contactno: "",
            QuantityOrderType: "",

            Price: "",
            TotalOffersReceived: "",
            TimeClockofBidEndTime: "",
            Comments: "",
            AccountRep: "",

            BidderEmail: data?.bidderEmail || '',
            BidderCompanyname: data?.bidderCompanyName?.replaceAll(",", " ").replaceAll(".", " ").replaceAll("\n", " ")?.replaceAll("\r", " ") || '',
            BidderContactno: data?.bidderPhoneNumber || '',
            BidderQuantity: data?.palletDetails ? orderType(data) + ' - $' + data?.bidPrice : '',

            BidderDate: moment(data?.bidDate.split('T')[0]).format("MM/DD/YYYY") || '',
            BidderDeliveryPUaddress: postBidAddress,

            PostStatus: items?.postStatus,
            OfferStatus: data?.bidStatus,

            BidderAccountRep: data?.bidderAccountRepresentative ? data?.bidderAccountRepresentative.join(' - ') : "NA",
            BidderComment: data?.bidComment || '',
          }
          return [mainReturnObj, chidReturnObj]
        } else {
          let chidReturnObj = {
            PostName: "",
            PosterEmail: "",
            PosterCompanyName: "",
            PrivateGroup: "",
            Deliveryaddress: "",

            City: "",
            State: "",
            Zip: "",
            Contactno: "",
            QuantityOrderType: "",

            Price: "",
            TotalOffersReceived: "",
            TimeClockofBidEndTime: "",
            Comments: "",
            AccountRep: "",

            BidderEmail: data?.bidderEmail || '',
            BidderCompanyname: data?.bidderCompanyName?.replaceAll(",", " ").replaceAll(".", " ").replaceAll("\n", " ")?.replaceAll("\r", " ") || '',
            BidderContactno: data?.bidderPhoneNumber || '',
            BidderQuantity: data?.palletDetails ? orderType(data) + ' - $' + data?.bidPrice : '',

            BidderDate: moment(data?.bidDate.split('T')[0]).format("MM/DD/YYYY") || '',
            BidderDeliveryPUaddress: postBidAddress,

            PostStatus: items?.postStatus,
            OfferStatus: items?.bidStatus,

            BidderAccountRep: data?.bidderAccountRepresentative ? data?.bidderAccountRepresentative.join(' - ') : "NA",
            BidderComment: data?.bidComment || '',
          }
          return chidReturnObj
        }
      })
      return resultObj.flat()
    } else {
      let postBidAddress = ''
      if (items?.postBidOrOfferInfo && items?.postBidOrOfferInfo[0]?.shippingAddress) {
        if (items?.postBidOrOfferInfo[0]?.shippingAddress?.address2) {
          postBidAddress = items?.postBidOrOfferInfo[0]?.shippingAddress?.address1 + '-' + items?.postBidOrOfferInfo[0]?.shippingAddress?.address2 + '-' + items?.postBidOrOfferInfo[0]?.shippingAddress?.city + '(' + (items?.postBidOrOfferInfo[0]?.shippingAddress?.stateAbv ? items?.postBidOrOfferInfo[0]?.shippingAddress?.stateAbv : stateConvert(items?.postBidOrOfferInfo[0]?.shippingAddress?.state)) + ')'
        }
        else {
          postBidAddress = items?.postBidOrOfferInfo[0]?.shippingAddress?.address1 + '-' + items?.postBidOrOfferInfo[0]?.shippingAddress?.city + '(' + (items?.postBidOrOfferInfo[0]?.shippingAddress?.stateAbv ? items?.postBidOrOfferInfo[0]?.shippingAddress?.stateAbv : stateConvert(items?.postBidOrOfferInfo[0]?.shippingAddress?.state)) + ')'
        }
      }

      let mainReturnObj = {
        PostName: items?.postName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        PosterEmail: items?.posterDetails?.email,
        PosterCompanyName: items?.postDetails?.shippingAddress?.locationName?.replaceAll(",", " ").replaceAll(".", " ").replaceAll("\n", " ")?.replaceAll("\r", " "),
        PrivateGroup: items?.postDetails?.private ? 'Yes' : 'No',
        Deliveryaddress: deliveryaddress,

        City: items?.postDetails?.shippingAddress?.city ? items.postDetails.shippingAddress.city.replace(/,$/, '') : '',
        State: (items?.postDetails?.shippingAddress?.stateAbv ? items?.postDetails?.shippingAddress?.stateAbv : stateConvert(items?.postDetails?.shippingAddress?.state)),
        Zip: 'Zip: ' + items?.postDetails?.shippingAddress?.zipCode,
        Contactno: items?.posterDetails?.phoneNumber,
        QuantityOrderType: quantityOrderType?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        Price: items?.postDetails?.postPrice ? `$${items.postDetails.postPrice}` : 'NA',
        TotalOffersReceived: items?.noOfBidsAndOffers,
        TimeClockofBidEndTime: getDate,
        Comments: items?.postcomments && items?.adminComments?.postCommentByAdmin && items?.adminComments?.postCommentByAdmin[0]?.msg,
        AccountRep: items?.accountRepresentative ? items?.accountRepresentative.join(' - ') : "NA",

        BidderEmail: items?.postBidOrOfferInfo[0]?.bidderEmail || '',
        BidderCompanyname: items?.postBidOrOfferInfo[0]?.bidderCompanyName?.replaceAll(",", " ").replaceAll(".", " ").replaceAll("\n", " ")?.replaceAll("\r", " ") || '',
        BidderContactno: items?.postBidOrOfferInfo[0]?.bidderPhoneNumber || '',
        BidderQuantity: items?.postBidOrOfferInfo[0]?.palletDetails ? orderType(items?.postBidOrOfferInfo[0]) + ' -$ ' + items?.postBidOrOfferInfo[0]?.bidPrice : '',
        BidderDate: moment(items?.postBidOrOfferInfo[0]?.bidDate.split('T')[0]).format("MM/DD/YYYY") || '',
        BidderDeliveryPUaddress: postBidAddress,

        PostStatus: items?.postStatus,
        OfferStatus: items?.postBidOrOfferStatus,

        BidderAccountRep: items?.postBidOrOfferInfo[0]?.bidderAccountRepresentative ? items?.postBidOrOfferInfo[0]?.bidderAccountRepresentative.join(' - ') : "NA",
        BidderComment: items?.postBidOrOfferInfo[0]?.bidComment || '',
      }
      return (mainReturnObj)
    }
  })
  // setInvCsvData(tempCsvData.flat())
  return tempCsvData.flat()
}

let csvFinalData = [];
const postVisibilityExportData = async (multiSelectCompanyVal, postType, requestFilter, bidStatusType, tableSearch, filterType, userFilterState, dispatch, setIsDownloadingPostVisibilityCSV, setCsvPostVisibilityData, csvPostVisibilityCurrentPage, setCsvPostVisibilityCurrentPage, setCsvPostVisibilityTotalPages) => {
  const companyArr = multiSelectCompanyVal?.map(company => company.value) || [];
  const data = {
    size: 50,
    number: csvPostVisibilityCurrentPage,
    postType,
    sort: requestFilter === "Ascending" ? "ASC" : "DESC",
    bidOfferStatus: [bidStatusType],
    searchBy: tableSearch || "",
    status: [filterType || userFilterState.status],
    companyId: companyArr.length ? companyArr : [userFilterState.company],
    startDate: userFilterState.fromDate,
    endDate: userFilterState.toDate,
    requestDate: true,
  };

  // Initial API call to get the first page and total pages
  const response = await dispatch(postVisibilityExportV2(data));

  if (response?.success) {
    const initialData = postType === "NEED" ? response?.data?.needList : response?.data?.inventoryList;
    const totalPages = response?.data?.totalPages ?? 1;

    setCsvPostVisibilityTotalPages(totalPages);
    setCsvPostVisibilityCurrentPage(csvPostVisibilityCurrentPage + 1);

    let resultApiData = [...initialData];

    // Function to process a batch of 10 requests
    const fetchBatch = async (startPage, batchSize) => {
      const pageRequests = Array.from(
        { length: batchSize },
        (_, i) => dispatch(postVisibilityExportV2({ ...data, number: startPage + i }))
      );

      // Execute the batch requests
      const batchResponses = await Promise.all(pageRequests);
      return batchResponses.flatMap(res =>
        res?.success ? (postType === "NEED" ? res?.data?.needList : res?.data?.inventoryList) : []
      );
    };

    // Iterate through pages in batches of 10
    for (let currentPage = csvPostVisibilityCurrentPage + 1; currentPage <= totalPages; currentPage += 10) {
      const batchSize = Math.min(10, totalPages - currentPage + 1);
      const batchData = await fetchBatch(currentPage, batchSize);

      // Update the result data
      resultApiData = [...resultApiData, ...batchData];

      // Update progress
      setCsvPostVisibilityCurrentPage(currentPage + batchSize - 1);
    }

    // Process and set the final data for CSV export
    const preparedCsvData = postType === "NEED"
      ? setNeedCSVDate(resultApiData)
      : setInvCSVData(resultApiData);

    setCsvPostVisibilityData(preparedCsvData);
    setIsDownloadingPostVisibilityCSV(false);

    // Trigger CSV export
    const csvExportRef = document.querySelector("#csvPostVisibilityExportRef");
    if (csvExportRef) {
      setTimeout(() => {
        csvExportRef.click();
      }, 500);
    }

    // Reset current page after completion
    setCsvPostVisibilityCurrentPage(0);
  } else {
    setIsDownloadingPostVisibilityCSV(false);
  }
};

export const ExportPostVisibility = (multiSelectCompanyVal, postType, requestFilter, bidStatusType, tableSearch, filterType, userFilterState, dispatch, setIsDownloadingPostVisibilityCSV, setCsvPostVisibilityData, csvPostVisibilityCurrentPage, setCsvPostVisibilityCurrentPage, setCsvPostVisibilityTotalPages) => {

  setIsDownloadingPostVisibilityCSV(true)
  csvFinalData = [];
  postVisibilityExportData(multiSelectCompanyVal, postType, requestFilter, bidStatusType, tableSearch, filterType, userFilterState, dispatch, setIsDownloadingPostVisibilityCSV, setCsvPostVisibilityData, csvPostVisibilityCurrentPage, setCsvPostVisibilityCurrentPage, setCsvPostVisibilityTotalPages)
}